document.addEventListener('DOMContentLoaded', function() {
    var loadingOverlay = document.getElementById('people-page-loading');
    var contentElement = document.getElementById('team-member-content');

    function showContent() {
        if (loadingOverlay) {
            loadingOverlay.style.opacity = '0';
            setTimeout(function() {
                loadingOverlay.style.display = 'none';
            }, 300);
        }

        if (contentElement) {
            contentElement.classList.add('loaded');
        }
    }

    function checkImagesLoaded() {
        var images = contentElement.querySelectorAll('img');
        var loadedImages = 0;
        var totalImages = images.length;

        if (totalImages === 0) {
            showContent();
            return;
        }

        images.forEach(function(img) {
            if (img.complete) {
                loadedImages++;
                if (loadedImages === totalImages) {
                    showContent();
                }
            } else {
                img.addEventListener('load', function() {
                    loadedImages++;
                    if (loadedImages === totalImages) {
                        showContent();
                    }
                });

                img.addEventListener('error', function() {
                    loadedImages++;
                    if (loadedImages === totalImages) {
                        showContent();
                    }
                });
            }
        });
    }

    setTimeout(checkImagesLoaded, 100);

    setTimeout(function() {
        if (loadingOverlay && loadingOverlay.style.display !== 'none') {
            showContent();
        }
    }, 3000);
});
